import { memo } from 'react'
import { Link } from "react-router-dom";
import { ErrorToastContainer } from '../../function/CustomFunction';

function Template({temPlate,index,DeleteTempate}) {
  // Check if this is an authentication template
  const isAuthTemplate = temPlate.category === 'AUTHENTICATION';
 
  return (
    <tr>
        <td>{index+1}</td>
        <td>{temPlate.template_name}</td>
        <td>{temPlate.language}</td>
        <td>{temPlate.category}</td>
        <td>{temPlate.score}</td>
        <td>{temPlate.template_id}</td>
        <td className={temPlate.status === 'APPROVED' ? 'text-success' : temPlate.status === 'PENDING' ? 'text-warning' : 'text-danger'}>{temPlate.status}</td>
        <td>{temPlate.last_edit_date}</td>
        <td>{temPlate.time}</td>
        <td>
            <Link 
              to={`/client-area/whatsapp/edit-template/${btoa(temPlate.id)}`} 
              className="btn btn-primary btn-rounded btn-fw p-2 py-1 text-white" 
              style={{fontSize: '13px'}}
            >
              Edit Template
            </Link>
        </td>
        <td>
            <button 
              type="button" 
              className="btn btn-info btn-rounded btn-fw p-2 py-1 text-white" 
              style={{fontSize: '13px'}} 
              onClick={()=> {
                DeleteTempate(btoa(temPlate.id));
              }}
            >
              Delete Template
            </button>
        </td>
        
    </tr>
  )
}

export default memo(Template)
